import { ShapeTypeEnum } from '../../types';
class HelpLinesComponentShape {
    constructor(shapeType, dimensions) {
        this.typeId = HelpLinesComponentShape.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.shapeType = ShapeTypeEnum.off;
        this.dimensions = [];
        this.shapeType = shapeType;
        this.dimensions = dimensions;
    }
    eq(other) {
        return this.shapeType === other.shapeType && this.dimensions === other.dimensions;
    }
}
HelpLinesComponentShape.id = 2074;
export default HelpLinesComponentShape;
//# sourceMappingURL=HelpLinesComponentShape.js.map